<form [formGroup]="lifecycleForm">
    <div class="col s12" style="padding-left: 0; padding-top: 15px">
        <app-input
            type="number"
            [formControl]="lifecycleForm.controls['toolRevisionPercent']"
            [showErrors]="showValidations"
            placeholder="{{ 'admin.tools.details.detailsPage.labels.revisionPercent' | translate }}"
            label="{{ 'admin.tools.details.detailsPage.labels.revisionPercent' | translate }}"
        >
        </app-input>
        <app-input-datepicker
            [formControl]="lifecycleForm.controls['expirationDate']"
            [showErrors]="showValidations"
            [appendTo]="'body'"
            placeholder="{{ 'admin.tools.details.detailsPage.labels.toolExpirationDate' | translate }}"
            label="{{ 'admin.tools.details.detailsPage.labels.toolExpirationDate' | translate }}">
        </app-input-datepicker>

        <app-input
            type="number"
            [formControl]="lifecycleForm.controls['partNumbersCount']"
            [showErrors]="showValidations"
            placeholder="{{ 'admin.tools.details.detailsPage.labels.partNumbersCount' | translate }}"
            label="{{ 'admin.tools.details.detailsPage.labels.partNumbersCount' | translate }}">
        </app-input>
    </div>
</form>
